/**
 * SuperAdminRoute Component
 * Protects routes that should only be accessible by superadmin users
 * Some routes may also allow users with specific privileges
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';

const SuperAdminRoute = ({ children }) => {
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has access to this specific route
  const hasAccess = () => {
    // Superadmin has access to everything
    if (user?.role === 'superadmin') {
      return true;
    }

    // Check specific route permissions
    if (location.pathname === '/compose-email') {
      return user?.canComposeEmail === true;
    }

    // All other routes require superadmin
    return false;
  };

  if (!hasAccess()) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-center">
          <div className="bg-red-50 border border-red-200 rounded-xl p-8 max-w-md mx-auto">
            <div className="flex items-center justify-center w-16 h-16 mx-auto mb-4 bg-red-100 rounded-full">
              <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">Access Restricted</h2>
            <p className="text-gray-600 mb-4">
              {location.pathname === '/compose-email' 
                ? 'You need Compose Email privilege to access this feature.'
                : 'This feature is only available to Super Admin users.'
              }
            </p>
            <p className="text-sm text-gray-500">
              Your current role: <span className="font-semibold capitalize">{user?.role?.replace(/_/g, ' ')}</span>
            </p>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default SuperAdminRoute;